export const getLastModal = () => Array.from(document.querySelectorAll('.rf-modal')).slice(-1)[0];
